import {
    Link
} from "react-router-dom";

export const Footer = () => {
    return (
        <footer>
            <div className="footer-middle">
                <div className="footer-card">
                    <p>Developer Team : </p>
                    <p className='ashish'>Ashish Tiwari</p>
                    <p className='dev-harshit'>Harshit Dubey</p>
                </div>
                <div className="footer-card">
                    <Link to="/login">Login</Link>
                    <a href="https://nitsri.ac.in/" target="_blank">NIT Srinagar</a>
                    <Link to="/credits">Credits</Link>
                    <Link to="/contact">Contact Us</Link>
                </div>
            </div>
        </footer>
    )
}